export function ArticleGridSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="overflow-hidden rounded-2xl border border-brand-outline-variant/50 bg-brand-surface-lowest"
        >
          <div className="aspect-[16/10] animate-pulse bg-brand-surface-container" />
          <div className="space-y-3 p-4">
            <div className="h-5 w-24 animate-pulse rounded-full bg-brand-surface-container" />
            <div className="h-6 w-full animate-pulse rounded bg-brand-surface-container" />
            <div className="h-4 w-2/3 animate-pulse rounded bg-brand-surface-container-low" />
          </div>
        </div>
      ))}
    </div>
  );
}
